import { zonedTimeToUtc, utcToZonedTime, format } from "date-fns-tz"
// import {parseISO} from "date-fns"


export function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

export function convertSecondsToMinutesSecondsFormat(prop) {
    console.log("convertSecondsToMinutesSecondsFormat prop", prop);
    if (prop === "NaN") { return '--'}
    if (typeof prop === "undefined") { return '--'; }

    let totalSecs = prop;
    let hours = Math.floor(totalSecs / 3600);
    let minutes = Math.floor((totalSecs % 3600) / 60);
    let seconds = (totalSecs % 60).toFixed();


    //let timeString = String.format("%02d:%02d", hours, minutes);
    let timeString;
    if (hours>0) {
        timeString = pad(hours,2)+':' +pad(minutes,2)+':'+pad(seconds,2);
    }
    else {
        timeString = pad(minutes,2)+':'+pad(seconds,2);
    }
    return timeString
}

export function convertSecondsToHourMinutesFormat(prop) {
    console.log("convertSecondsToMinutesSecondsFormat prop", prop);
    if (prop === "NaN") { return '--'}
    if (typeof prop === "undefined") { return '--'; }

    let totalSecs = prop;
    let hours = Math.floor(totalSecs / 3600);
    let minutes = Math.floor((totalSecs % 3600) / 60);
    let seconds = (totalSecs % 60).toFixed();


    //let timeString = String.format("%02d:%02d", hours, minutes);
    let timeString;
    if (hours>0) {
        timeString = pad(hours,2)+':' +pad(minutes,2);
    }
    else {
        timeString = pad(minutes,2);
    }
    return timeString
}


// export function pad(n) {
//   return n<10 ? '0'+n : n;
// }

export function convertISODateTimeToBRLocale(prop, displaySeconds) {
    displaySeconds = displaySeconds || false;
    if (!prop || prop === null) return "";
    //debugger;
    var dt  = new Date(prop);
   var day = dt.getDate();
   var month = dt.getMonth() + 1;
   var year = dt.getFullYear();
   var hour = dt.getHours();
   var minute = dt.getMinutes();
   var seconds = dt.getSeconds();
   var r = pad(day,2) + "/" + pad(month,2) + "/" + pad(year,4) + " " + pad(hour,2) + ":"  + pad(minute,2);
   //console.log
   r =  displaySeconds? r+":"+pad(seconds,2) : r;

   return r;
}

export function convertISODateTimeToHHmmBRLocale(prop, displaySeconds) {
    displaySeconds = displaySeconds || false;
    if (!prop || prop === null) return "";
    //debugger;
    var dt  = new Date(prop);
    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    var year = dt.getFullYear();
    var hour = dt.getHours();
    var minute = dt.getMinutes();
    var seconds = dt.getSeconds();
    var r = pad(hour,2) + ":"  + pad(minute,2);
    //console.log
    r =  displaySeconds? r+":"+pad(seconds,2) : r;

    return r;
}

export function convertISODateTimeToDDMMHHmmBRLocale(prop, displaySeconds) {
    displaySeconds = displaySeconds || false;
    if (!prop || prop === null) return "";
    //debugger;
    var dt  = new Date(prop);
    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    var year = dt.getFullYear();
    var hour = dt.getHours();
    var minute = dt.getMinutes();
    var seconds = dt.getSeconds();
    var r = pad(day,2) +"/" + pad(month,2)+" "+ pad(hour,2) + ":"  + pad(minute,2);
    //console.log
    r =  displaySeconds? r+":"+pad(seconds,2) : r;

    return r;
}


export function convertISODateTimeToTz(prop) {
    if (!prop || prop === null) return "";
    var dt  = new Date(prop);

    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    var year = dt.getFullYear();
    var hour = dt.getHours();
    var minute = dt.getMinutes();
    //var seconds = dt.getSeconds();
    var r = pad(day,2) + "/" + pad(month,2) + "/" + pad(year,4) + " " + pad(hour,2) + ":"  + pad(minute,2) ;
    return r;

    // const timeZone = 'America/Sao_Paulo'
    // const zonedDate = utcToZonedTime(dt, timeZone);
    // return zonedDate.toISOString();
/*
    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    var year = dt.getFullYear();
    var hour = dt.getHours();
    var minute = dt.getMinutes();
    //var seconds = dt.getSeconds();
    var r = pad(day,2) + "/" + pad(month,2) + "/" + pad(year,4) + " " + pad(hour,2) + ":"  + pad(minute,2) ;
    return r;

 */
}

export function convertISODateTimeToHHMMTz(prop) {
    if (!prop || prop === null) return "";
    var dt  = new Date(prop);

    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    var year = dt.getFullYear();
    var hour = dt.getHours();
    var minute = dt.getMinutes();
    //var seconds = dt.getSeconds();
    var r = pad(day,2) + "/" + pad(month,2) + " " + pad(hour,2) + ":"  + pad(minute,2) ;
    return r;
}

export function commercialHoursInInterval(dtmin, dtmax, cargaHorariaDia) {
    cargaHorariaDia = cargaHorariaDia | 10;
    var timeDiff = new Date(dtmax).getTime() - new Date(dtmin).getTime();
    console.log('commercialHoursInInterval timediff chd', timeDiff, cargaHorariaDia);
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) * cargaHorariaDia ;
 //   console.log('diffDays', diffDays)
    return diffDays;
}

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};
